import {
  ADD_PROJECT,
  CHANGE_PROJECT,
  CREATE_PROJECT_ERRORS,
  DELETE_PROJECT,
  NEW_PROJECT_LOADING,
  SET_PROJECT,
  SET_PROJECTS,
  SET_PROJECTS_OTIONS,
  SUCCESSFUL_EDIT_PROJECT,
  ADD_PROJECT_FILE, REMOVE_PROJECT_FILE,
  SET_PROJECTS_EXTENDED,
  REMOVE_PROJECT_ERRORS,
} from "./actionTypes";
import axios from "axios";
import {setProjectModal} from "./modals";
import {getMonthDurationFromStartDate} from "./userProjects";
import { history } from "../store";

export const setProjects = (projects = null) => {
  return {
    type: SET_PROJECTS,
    payload: projects
  };
};

export const setProjectsExtended = (projects = null) => {
  return {
    type: SET_PROJECTS_EXTENDED,
    payload: projects
  };
};

export const setProjectsOptions = (projects = null) => {
  return {
    type: SET_PROJECTS_OTIONS,
    payload: projects
  };
};

export const getProjects = () => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    axios.get(`/api/v1/project`)
      .then(res => {
        let projects = res.data;
        projects = projects.map(project => {
          if(!project.isFinished) {
            project.durationMonths = getMonthDurationFromStartDate(project.startDate);
          }
          return project;
        });
        dispatch(setProjects(projects));
      })
  }
};

export const getProjectsExtended = () => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    axios.get(`/api/v1/project/extended`)
      .then(res => {
        let projects = res.data;
        projects = projects.map(project => {
          if(!project.isFinished) {
            project.durationMonths = getMonthDurationFromStartDate(project.startDate);
          }
          return project;
        });
        dispatch(setProjectsExtended(projects));
      })
  }
};

export const getProjectsOptions = () => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    axios.get(`/api/v1/project/options`)
      .then(res => {
        dispatch(setProjectsOptions(res.data));
      })
  }
};

export const newProjectLoading = (bool = false) => {
  return {
    type: NEW_PROJECT_LOADING,
    payload: bool
  };
};

export const addProject = (project) => {
  return {
    type: ADD_PROJECT,
    payload: project
  }
};

export const createProjectErrors = (errors = {}) => {
  return {
    type: CREATE_PROJECT_ERRORS,
    payload: errors
  };
};

export const removeProjectErrors = () => {
  return {
    type: REMOVE_PROJECT_ERRORS
  }
}

export const createProject = (project) => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    dispatch(newProjectLoading(true));
    const formData = getFormDataFromProject(project);
    axios.post('/api/v1/project', formData)
      .then(res => {
        dispatch(setProjectModal(false));
        const projectForEditing = res.data;
        if (!projectForEditing.isFinished) {
          projectForEditing.durationMonths = getMonthDurationFromStartDate(projectForEditing.startDate)
        }
        dispatch(addProject(projectForEditing));
      })
      .catch(errors => {
        dispatch(createProjectErrors((errors.response && errors.response.data.errors) || {non_field_errors: [errors.message]}));
      }).finally(() => {
      dispatch(newProjectLoading(false));
    })
  }
};

export const removeProject = (project) => {
  return {
    type: DELETE_PROJECT,
    payload: project
  }
};

export const deleteProject = (projectId) => {
  return (dispatch) => {
    axios.delete(`/api/v1/project/${projectId}`)
      .then(res => {
        dispatch(removeProject(res.data))
      })
  }
};

export const successfulEditProject = (projectId) => {
  return {
    type: SUCCESSFUL_EDIT_PROJECT,
    payload: projectId
  };
};

export const changeProject = (project) => {
  return {
    type: CHANGE_PROJECT,
    payload: project
  }
};

export const editProject = (project) => {
  return (dispatch) => {
    dispatch(newProjectLoading(true));
    dispatch(createProjectErrors({}));
    const formData = project.image ? getFormDataFromProject(project) : project;
    axios.patch(`/api/v1/project/${project.id}`, formData)
      .then(res => {
        dispatch(setProjectModal(false));
        const projectForEditing = res.data;
        if (!projectForEditing.isFinished) {
          projectForEditing.durationMonths = getMonthDurationFromStartDate(projectForEditing.startDate)
        }
        dispatch(setProject(projectForEditing));
        dispatch(changeProject(projectForEditing))
      }).catch(errors => {
      dispatch(createProjectErrors((errors.response && errors.response.data.errors) || {non_field_errors: [errors.message]}));
    }).finally(() => {
      dispatch(newProjectLoading(false));
    });
  }
};

export const setProject = (projects = {}) => {
  return {
    type: SET_PROJECT,
    payload: projects
  };
};

export const getProject = (projectId, userId) => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    axios.get(`/api/v1/project/${projectId}`)
      .then(res => {
        const project = res.data;
        if (!project.isFinished) {
          project.durationMonths = getMonthDurationFromStartDate(project.startDate)
        }
        dispatch(setProject(project));
      })
      .catch((rej) => {
        if (rej.response.status === 403) {
          history.push(`/home/${userId}/projects`)
        }
      });
  }
};

export const addProjectFile = (file = {}) => ({
  type: ADD_PROJECT_FILE,
  payload: file
});



export const createProjectFile = (projectId, data) => {
  return (dispatch) => {
    dispatch(createProjectErrors({}));
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('groupId', data.group);
    return axios.post(`/api/v1/project/${projectId}/files`, formData)
      .then(res => {
        dispatch(addProjectFile(res.data));
      })
      .catch(errors => {
        dispatch(createProjectErrors((errors.response && errors.response.data.errors) || {non_field_errors: [errors.message]}));
      })
  }
};

export const removeProjectFile = (projectFileId) => ({
  type: REMOVE_PROJECT_FILE,
  payload: projectFileId
});

export const deleteProjectFile = (projectFileId) => {
  return (dispatch) => {
    axios.delete(`/api/v1/file/${projectFileId}`)
      .then(({data: {id: projectFileId}}) => {
        dispatch(removeProjectFile(projectFileId))
      })
  }
};

export const getFormDataFromProject = (project) => {
  const formData = new FormData();
  project.image instanceof Blob && formData.append('image', project.image);
  formData.append('name', project.name);
  formData.append('url', project.url);
  formData.append('description', project.description);
  formData.append('durationMonths', project.durationMonths ? project.durationMonths : 0);
  formData.append('isFinished', project.isFinished);
  formData.append('startDate', project.startDate);
  return formData;
};



// WEBPACK FOOTER //
// ./src/actions/projects.js